const DocTitle = ({ title }) => {
    return (
        <div id="doc-title">{title}</div>
    )
}

export default DocTitle;